import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/route-guard/AuthGuard';

const Dashboard = Loadable(lazy(() => import('pages/mineacs/Dashboard')));
// const MiaChat = Loadable(lazy(() => import('pages/mineacs/MiaChat')));
const LiveMap = Loadable(lazy(() => import('pages/mineacs/LiveMap')));
const Telemetry = Loadable(lazy(() => import('pages/mineacs/Telemetry')));
const Events = Loadable(lazy(() => import('pages/mineacs/Events')));
const Devices = Loadable(lazy(() => import('pages/mineacs/Devices')));
const Settings = Loadable(lazy(() => import('pages/mineacs/Settings')));
const Geofences = Loadable(lazy(() => import('pages/mineacs/Geofences')));
const Drivers = Loadable(lazy(() => import('pages/mineacs/Drivers')));
const Reports = Loadable(lazy(() => import('pages/mineacs/Reports')));
const NotFound = Loadable(lazy(() => import('pages/maintenance/error/404')));

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="/dashboard" replace />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    // MIA route is temporarily disabled until the module is ready to be shown again.
    // {
    //   path: 'mia',
    //   element: <MiaChat />
    // },
    {
      path: 'live-map',
      element: <LiveMap />
    },
    {
      path: 'telemetry',
      element: <Telemetry />
    },
    {
      path: 'events',
      element: <Events />
    },
    {
      path: 'devices',
      element: <Devices />
    },
    {
      path: 'settings',
      element: <Settings />
    },
    {
      path: 'geofences',
      element: <Geofences />
    },
    {
      path: 'drivers',
      element: <Drivers />
    },
    {
      path: 'reports',
      element: <Reports />
    },
    {
      path: '*',
      element: <NotFound />
    }
  ]
};

export default MainRoutes;
